import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import helper from "../../lib/helper";
import cartModel from "../../models/cart.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import moment from "moment/moment";
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);

    const router = useRouter();
    const queryParams = router.query;
    const { data: cartData, mutate: reloadcartData, isLoading } = useSWR(
        queryParams || null,
        () => cartModel.list(queryParams),
        config.swrConfig
    );

    const columns = [

        {
            Header: 'Id',
            accessor: 'id',

            Cell: ({ row }) => (
                <>

                    {row.original.id}
                </>
            )
        },

        {
            Header: 'Name',
            accessor: 'name',
            Cell: ({ row }) => (
                <>
                    {row.original.user?.name || 'unknown'}
                </>
            )
        },

        {
            Header: 'Mobile',
            id: 'mobile',
            Cell: ({ row }) => (
                <>

                    {row.original.user?.mobile}
                </>
            )
        },
        {
            Header: "Total-Mrp",
            accessor: "mrp",
            className: "col"
        },
        {
            Header: "Total-Amount",
            accessor: "amount",
            className: "col"
        },
        {
            Header: "Discount",
            accessor: "discount",
            className: "col"
        },
        {
            Header: "Status",
            accessor: "status",
            className: "col"
        },
        {
            Header: "Payment mode",
            accessor: "payment_mode",
            className: "col"
        },
        {
            Header: "Created At",

            className: "col",
            Cell: ({ row }) => (

                <>{helper.date.format(row.original.created_at)}
                </>
            )
        },
        {
            className: "col-auto text-end",
            Header: "Actions",
            id: "action",
            Cell: ({ row }) => (
                <>

                    <Link
                        className="btn btn-primary"
                        href={`/cart/${row.original.id}`}
                    >
                        <i className="bi bi-eye"></i>
                    </Link>


                </>
            ),
        },

    ];

    return (
        <>
            <Heading title="Cart" showLoader={isLoading || showLoader}>

            </Heading>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">Cart List</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={cartData?.data || []} />
                    </div>
                    <div className="card-footer table-responsive p-0">
                        <Pagination meta={cartData?.meta} />
                    </div>

                </div>

            </div>



        </>
    );
};

export default Page;
